export default function TextX({ content }) {
  return (
    <div
      className=" shrink-0 mb-c4
       font-bold text-black222 
      underline decoration-2 underline-offset-4 main-color "
    >
      {content}
    </div>
  );
}
